// index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './redux/store';
import { Provider } from 'react-redux';

// Получаем корневой элемент из DOM
const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error("Не удалось найти элемент с id 'root' в документе.");
}

// Создаем корневой рендерер
const root = ReactDOM.createRoot(rootElement);

// Рендерим приложение
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);

// Функция для измерения производительности
reportWebVitals();
